<template>
  <div id="consult">
    <!-- container -->
    <div class="containers">
      <!-- section -->
      <Section :topMenu="menu.topMenu[2]"></Section>
      <div class="content_wrap">
        <!-- side-menu -->
        <SideMenu :sideMenu="menu.consult" :topMenu="menu.topMenu[2]"></SideMenu>
        <!-- content -->
        <div class="main_content">
          <div class="sub_content">
            <!-- 바뀌는 곳  -->
            <router-view name="changeTab3"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/static/SideMenu.vue'
import Section from '@/components/static/Section.vue'

export default {
  name: 'Consult',
  data() {
    return {}
  },
  methods: {},
  props: {
    menu: Object,
  },
  components: { SideMenu, Section },
}
</script>

<style>
@import '@/style/board.css';
</style>
